import styled from 'styled-components';
import { rem } from 'polished';

const baseFont = '12px';
const S = {};

const FwSemibold = ({theme:{$fwSemibold}}) => `${$fwSemibold}`;
const FwRegular = ({theme:{$fwRegular}}) => `${$fwRegular}`;

const InputErrorColor = ({theme: {$inputErrorColor}}) => `${$inputErrorColor}`;
const InputColor = ({theme: {$inputColor}}) => `${$inputColor}`;
const InputActiveColor = ({theme: {$inputActiveColor}}) => `${$inputActiveColor}`;
const InputLabelColor = ({theme: {$inputLabelColor}}) => `${$inputLabelColor}`;
const InputPlaceholderColor = ({theme: {$inputPlaceholderColor}}) => `${$inputPlaceholderColor}`;
const InputBackgroundColor = ({theme: {$inputBackgroundColor}}) => `${$inputBackgroundColor}`;
const SubmitButtonTextColor = ({theme: {$submitButtonTextColor}}) => `${$submitButtonTextColor}`;
const FooterTextColor = ({theme: {$footerTextColor}}) => `${$footerTextColor}`;
const CheckedCheckboxColor = ({theme: {$checkedCheckboxColor}}) => `${$checkedCheckboxColor}`;
const CheckboxBorderColor = ({theme: {$checkboxBorderColor}}) => `${$checkboxBorderColor}`;
const LabelTextColor = ({theme: {$labelTextColor}}) => `${$labelTextColor}`;
const InfoBorderColor = ({theme: {$infoBorderColor}}) => `${$infoBorderColor}`;
const SubmissionErrorColor = ({theme: {$submissionErrorColor}}) => `${$submissionErrorColor}`;
const SubmissionErrorBackgroundColor = ({theme: {$submissionErrorBackgroundColor}}) => `${$submissionErrorBackgroundColor}`;

S.FormStep3 = styled.form`
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

S.InputsSection = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: ${rem('16px')};
    margin-bottom: ${rem('32px')};
`;

S.ConsentsSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem('12px')};
`;

S.InputWrapper = styled.div` 
    position: relative; 
    width: 100%; 
`;

S.Input = styled.input`
    width: 100%;
    box-sizing: border-box;
    height: ${rem('40px')};
    padding: 0 ${rem('16px')};
    font-size: ${rem('14px')};
    border-radius: 4px;
    background: ${InputBackgroundColor};
    transition: border-color 0.2s;

    border: 1px solid ${props => props.hasError ? InputErrorColor : InputColor};

    &:focus {
        outline: none;
        border-color: ${props => props.hasError ? InputErrorColor : InputColor};
    }

    &:disabled {
        color: ${InputPlaceholderColor};
        cursor: not-allowed;
        border-color: ${InputColor};
    }

    &::placeholder {
        color: ${InputPlaceholderColor};
    }
`;

S.PasswordToggler = styled.button`
    position: absolute;
    right: ${rem('12px')};
    top: ${rem('14px')};
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    z-index: 2;
`;

S.PasswordTogglerIcon = styled.i`
    color: ${props => props.isActive ? InputActiveColor : InputColor};
    width: ${rem('16px')};
    height: ${rem('16px')};
    font-size: ${rem('16px')};
`;

S.FloatingLabel = styled.span`
    position: absolute;
    top: -8px; left: 12px;
    background: ${InputBackgroundColor};
    padding: 0 4px;
    font-size: ${rem('10px')};
    color: ${InputLabelColor};
    z-index: 1;
`;

S.CheckIcon = styled.span` 
    color: ${InputLabelColor};
    font-size: ${rem('16px')}; 
`;

S.ErrorText = styled.div` 
    color: ${InputErrorColor};
    font-size: 10px; 
`;

S.CheckboxRow = styled.div`
    display: flex;
    align-items: center;
    gap: ${rem('12px')};
`;

S.CheckboxWrapper = styled.div` 
    flex-shrink: 0; 
`;

S.HiddenInput = styled.input` 
    position: absolute; 
    opacity: 0; 
    width: 0; 
`;

S.FakeCheckbox = styled.label`
    width: ${rem('18px')};
    height: ${rem('18px')};
    border: 1px solid ${props => props.checked ? CheckedCheckboxColor : CheckboxBorderColor};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

S.CheckMark = styled.span` 
    font-size: ${rem('14px')}; 
    font-weight: 900; 
    color: ${CheckedCheckboxColor};
`;

S.Label = styled.label` 
    font-size: ${rem('12px')}; 
    color: ${LabelTextColor}; 
    cursor: pointer; 
    font-weight: ${FwRegular};
`;

S.LabelPart = styled.span` 
    display: block; 
`;

S.Details = styled.details` 
    margin-top: 4px; 
`;

S.Summary = styled.summary`
    font-weight: ${FwSemibold}; 
    color: ${InputErrorColor}; 
    cursor: pointer; 
    list-style: none;
    outline: none;

    &::-webkit-details-marker { display: none; }

    &:after { content: '${props => props.moreText}'; }

    details[open] & {
        margin-bottom: 8px;
        &:after { content: '${props => props.lessText}'; }
    }
`;

S.AdminInfo = styled.div` 
    font-size: ${rem('12px')}; 
    color: ${LabelTextColor}; 
    margin: ${rem('12px')} 0; 
    padding-bottom: ${rem('16px')};
    border-bottom: 1px solid ${InfoBorderColor};
    width: 100%;
    line-height: 1.4;
`;

S.SubmitBtn = styled.button`
    width: 100%; 
    height: ${rem('40px')};
    font-size: ${rem('14px')};
    background-color: ${InputErrorColor};
    color: ${SubmitButtonTextColor};
    border: none; 
    border-radius: 3px; 
    font-weight: ${FwSemibold};
    margin-top: 24px; 
    cursor: pointer; 
    text-transform: uppercase;
    
    &:disabled { 
        opacity: 0.6; 
        cursor: not-allowed; 
    }
`;

S.FooterInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem('4px')};
    margin-top: ${rem('24px')};
    text-align: center;
`;

S.ContactInfo = styled.div`
    font-size: ${rem('12px')};
    color: ${FooterTextColor};
`;

S.ContactLink = styled.span`
    color: ${InputErrorColor};
    font-weight: ${FwSemibold};
    font-size: ${rem('12px')};
    cursor: pointer;
`;

S.SubmissionError = styled.div`
    box-sizing: border-box;
    margin: 0;
    border-radius: .25rem;
    width: 100%;
    color: ${SubmissionErrorColor};
    font-size: 1rem;
    text-align: left;
    padding: .83rem;
    background-color: ${SubmissionErrorBackgroundColor};
    margin-bottom: ${rem('20px')};
`;

export default S;